import { EVENTS_BY_SLUG, formatDateRangeLong } from '@/features/events';
import { Page } from '@/components/layout';
import { HeroCancun } from './sections/HeroCancun';
import { ProgramaCancun } from './sections/ProgramaCancun';
import { StripPremiumCancun } from './sections/StripPremiumCancun';
import { AntesDeReservarCancun } from './sections/AntesDeReservarCancun';
import { AzrahelCancun } from './sections/AzrahelCancun';
import { TarifasCancun } from './sections/TarifasCancun';
import { CtaBand, PorQueIr, ReservaCta } from '@/pages/shared/ConversionBlocks';

/**
 * `/cancun` · Cancún / Riviera Maya VIP — calco de `DEMO_5_CancunVIP.png`.
 *
 * LA PÁGINA PREMIUM DEL PROYECTO. No es una conferencia recoloreada: es un
 * retiro. Lo que la separa de las otras cinco es menos texto, más aire, un
 * único CTA que manda y ornamento dorado con oficio.
 *
 * CUATRO secciones del mockup, no cinco: hero frente al mar (40 %) · programa
 * (34 %) · strip de decisión (9 %) · cierre de marca (17 %). Menos es más caro.
 *
 * Más UN bloque que el mockup no dibuja y el brief exige (ADR-006):
 * `AntesDeReservarCancun` — prueba social real, FAQ y enlace de vuelta a la
 * gira. Va DESPUÉS del strip de decisión y ANTES del cierre de marca: quien
 * duda lo hace justo después de ver el CTA, y el bloque de Azrahel tiene que
 * seguir siendo lo último que se lee. Sin upsell: Cancún ES el techo del
 * embudo. Declarado en `docs/VISUAL_DEVIATIONS.md` §1.14.
 */
export function CancunVipPage() {
  const event = EVENTS_BY_SLUG.cancun;

  return (
    <Page
      documentTitle={event.city}
      description={`${event.title} · retiro vivencial premium en ${event.city}, ${formatDateRangeLong(event)}.`}
      tone={event.heroTone}
    >
      <HeroCancun event={event} />
      {/* La misma estructura que las otras cuatro (encargo del cliente,
          28-jul-2026), en su versión premium: el CTA de reserva es oro, no navy.
          Aquí NO hay upsell —Cancún ES el techo del embudo— y el «por qué ir»
          recoge el `salesHook` que hasta hoy vivía dentro de `ProgramaCancun`:
          se mueve, no se duplica. */}
      <ReservaCta event={event} variant="premium" />
      {/* Precios del hotel, encargo del cliente (docx, 14-sep-2026): la plaza no
          incluye el hospedaje, así que lo que cuesta va justo después de reservar. */}
      <TarifasCancun />
      <ProgramaCancun event={event} />
      {/* El botón del vídeo YA NO ESTÁ AQUÍ: subió al hero. Estuvo en esta
          banda medio día y, medido en la página publicada, quedaba a 2.827 px
          del borde —tres pantallas de scroll— donde no lo encontraba nadie.
          Ver `HeroCancun` y `VISUAL_DEVIATIONS` §O-5. */}
      <CtaBand event={event} variant="premium" />
      <PorQueIr event={event} variant="premium" background="alt" />
      <StripPremiumCancun event={event} />
      <AntesDeReservarCancun event={event} />
      <AzrahelCancun />
    </Page>
  );
}
